// docs/41 PZ6–PZ7: the hint shop's prices, exactly as `fk_world::puzzle::buy_hint` reckons them.
// Hints are bought on credit from the room's reward: every hero's XP for the room falls by the
// price, never below the floor (a tenth of the reward, at least 1). Force takes all that is left.

export const HINT_NUDGE = 0, HINT_RECALL = 1, HINT_STEP = 2, HINT_FORCE = 3;
/** Price in basis points of the reward for Nudge, Recall and Step (server `HINT_PRICE_BP`). */
export const HINT_PRICE_BP = [2000, 2500, 4000] as const;

export const HINTS = [
  { kind: HINT_NUDGE, name: 'Nudge', what: 'Where to look next' },
  { kind: HINT_RECALL, name: 'Recall a clue', what: 'One clue you have not found' },
  { kind: HINT_STEP, name: 'Show the next step', what: 'The next step spelled out — for the lock, its answer' },
  { kind: HINT_FORCE, name: 'Force the gate', what: 'The way gives at the end of the turn; the room pays only its floor' },
] as const;

/** The reward's floor: what a forced room still pays each hero. */
export const rewardFloor = (reward: number): number => Math.max(1, Math.floor(reward / 10));

/** XP still available on credit before the floor. */
export const creditLeft = (reward: number, debt: number): number => Math.max(0, reward - debt - rewardFloor(reward));

/** What the room pays each hero now, hints paid. */
export const rewardNow = (reward: number, debt: number): number => Math.max(reward - debt, rewardFloor(reward));

/** Price of hint `kind` in XP each. */
export function hintPrice(kind: number, reward: number, debt: number): number {
  if (kind === HINT_FORCE) return creditLeft(reward, debt);
  const bp = HINT_PRICE_BP[kind];
  return bp === undefined ? 0 : Math.ceil((reward * bp) / 10000);
}

/** Why hint `kind` cannot be bought now, if it cannot (the server refuses these too). */
export function hintBlocked(kind: number, reward: number, debt: number, forced: boolean, cluesHeld: number, clueTotal: number): string | undefined {
  if (forced) return 'The gate is already forced';
  if (kind === HINT_FORCE) return undefined;
  if (kind === HINT_RECALL && cluesHeld >= clueTotal) return 'You hold every clue already';
  const left = creditLeft(reward, debt);
  if (hintPrice(kind, reward, debt) > left) return `Only ${left} XP left on credit — force the gate instead`;
  return undefined;
}
